import type { FC } from 'react';
import { Table } from 'reactstrap';
import { WrapperClassWrapper } from './WrapperClass.styled';

interface WrapperClassProps { }

const WrapperClass: FC<WrapperClassProps> = () => (
   <WrapperClassWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Wrapper Class</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">A class that contains the primitive data types is known as a Wrapper class. It provides a way to use primitive data types as objects. An object is required to support synchronization in multi-threading, serialization and useful in the collection framework. Following are the eight wrapper classes given below :</p>
         <Table striped bordered>
            <thead>
               <tr>
                  <th className="text-align-center">Primitive data type</th>
                  <th className="text-align-center">Wrapper class</th>
               </tr>
            </thead>
            <tbody>
               <tr>
                  <td className="text-align-center">int</td>
                  <td className="text-align-center">Integer</td>
               </tr>
               <tr>
                  <td className="text-align-center">char</td>
                  <td className="text-align-center">Char</td>
               </tr>
               <tr>
                  <td className="text-align-center">byte</td>
                  <td className="text-align-center">Byte</td>
               </tr>
               <tr>
                  <td className="text-align-center">short</td>
                  <td className="text-align-center">Short</td>
               </tr>
               <tr>
                  <td className="text-align-center">long</td>
                  <td className="text-align-center">Long</td>
               </tr>
               <tr>
                  <td className="text-align-center">float</td>
                  <td className="text-align-center">Float</td>
               </tr>
               <tr>
                  <td className="text-align-center">double</td>
                  <td className="text-align-center">Double</td>
               </tr>
               <tr>
                  <td className="text-align-center">boolean</td>
                  <td className="text-align-center">Boolean</td>
               </tr>
            </tbody>
         </Table>
         <br/>
         <p  className="text-align-justify">In this section, the below-mentioned topics we will be covered:</p>
         <ul  className="text-align-justify">
            <li>Autoboxing & Unboxing</li>
            <li>Typecasting</li>
         </ul>
      </div>
   </WrapperClassWrapper>
);

export default WrapperClass;
